<template>
  <fieldset>
    <heading class="mb-6 font-bold" :level="2">{{ $t('Your billing address') }}</heading>
    <div class="mb-6">
      <div class="mb-2 font-semibold">
        <label for="name">{{ $t('subscription.fields.company-name') }}</label>
      </div>
      <div>
        <input
          id="company"
          :value="billingDetails.company"
          name="company"
          type="text"
          autocomplete="company"
          class="form-control form-input form-input-bordered w-full"
          @input="handleInput($event.target)"
        >
      </div>
    </div>
    <div class="mb-6">
      <div class="mb-2 font-semibold">
        <label for="email">{{ $t('Billing E-Mail') }}</label>
      </div>
      <div>
        <input
          id="email"
          :value="billingDetails.email"
          name="email"
          type="email"
          autocomplete="email"
          class="form-control form-input form-input-bordered w-full"
          @input="handleInput($event.target)"
        >
      </div>
    </div>
    <div class="flex mb-6">
      <div class="flex-1 mr-4">
        <div class="mb-2 font-semibold">
          <label for="address">{{ $t('Street name and number') }}</label>
        </div>
        <div>
          <input
            id="address"
            :value="billingDetails.address"
            name="address"
            type="text"
            autocomplete="address"
            class="form-control form-input form-input-bordered w-full"
            @input="handleInput($event.target)"
          >
        </div>
      </div>
      <div class="flex-1">
        <div class="mb-2 font-semibold">
          <label for="city">{{ $t('City/town') }}</label>
        </div>
        <div>
          <input
            id="city"
            :value="billingDetails.city"
            name="city"
            type="text"
            autocomplete="city"
            class="form-control form-input form-input-bordered w-full"
            @input="handleInput($event.target)"
          >
        </div>
      </div>
    </div>
    <div class="flex mb-6">
      <div class="flex-1 mr-4">
        <div class="mb-2 font-semibold">
          <label for="zip">{{ $t('Postal Code') }}</label>
        </div>
        <div>
          <input
            id="zip"
            :value="billingDetails.zip"
            name="zip"
            type="text"
            autocomplete="zip"
            class="form-control form-input form-input-bordered w-full"
            @input="handleInput($event.target)"
          >
        </div>
      </div>
      <div class="flex-1">
        <div class="mb-2 font-semibold">
          <label for="country">{{ $t('Country') }}</label>
        </div>
        <select-control
          id="country"
          :value="billingDetails.country"
          class="w-full"
          :options="countries"
          @input="handleInput({name: 'country', value: $event})"
        />
      </div>
    </div>
    <div class="mb-2 font-semibold">
      <label for="vat">{{ $t('VAT number / tax ID (optional)') }}</label>
    </div>
    <div>
      <input
        id="vat"
        :value="billingDetails.vat"
        name="vat"
        type="text"
        autocomplete="vat"
        class="form-control form-input form-input-bordered w-full"
        @input="handleInput($event.target)"
      >
    </div>
  </fieldset>
</template>

<script>
  import { list as getCountryList } from '@/services/api/resources/country';
  import { useTask } from '@/ui/concerns';

  export default {
    name: 'BillingAddress',

    props: ['billingDetails'],

    data() {
      return {
        stripeCountries: [],
      };
    },

    computed: {
      countries() {
        return this.stripeCountries.map(({ name, code }) => ({
          label: name,
          value: code,
        }));
      },
    },

    async created() {
      useTask(
        () => getCountryList(),
        countriesResponse => {
          this.stripeCountries = countriesResponse.data;
        },
      ).run();
    },

    methods: {
      handleInput({ name, value }) {
        this.$emit('input', {
          name,
          value,
        });
      },
    },
  };
</script>
